/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Products } from '../../models/products';

export interface CatalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet$Params {
  catalogEntryId: string;
  'Active-Tenant-Identifier': string;
}

export function catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet(http: HttpClient, rootUrl: string, params: CatalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Products>> {
  const rb = new RequestBuilder(rootUrl, catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet.PATH, 'get');
  if (params) {
    rb.path('catalogEntryId', params.catalogEntryId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Products>;
    })
  );
}

catalogEntriesModifierGroupsCatalogEntryIdRelationshipsGet.PATH = '/catalog-entries/modifier-groups/{catalogEntryId}/relationships';
